import { Store } from "vuex";
import { AdobePageLoadEvent } from "./adobe-page-load";
import { AppState } from "@/store";
import { ServicesContainer } from "@/services";
import { WebPageDetails } from "../models";
import { AdobeBaseEvent } from '@/services/analytics/platforms/adobe-analytics/adobe-events/adobe-base-event';

export class AdobeOrderReviewEvent extends AdobePageLoadEvent {
  constructor(event: AdobeBaseEvent, store: Store<AppState>, services: ServicesContainer) {
    super(store, services);

    Object.assign(this.web.webPageDetails, {
      name: `order:checkout:review-order`,
      page: 'home',
      pageType: 'checkout',
      pageViews: { "value": 1 },
      siteSection: 'order',
      subSection1: 'checkout',
    } as WebPageDetails);

    Object.assign(this.commerce, {
      orderNowClicks: { "value": 1 },
      orderReview: { "value": 1 },
      orderSubmitClick: { "value": 1 }
    });
  }
}